import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { catchError, map, Observable, throwError, timeout } from 'rxjs';

import { UserService } from '@authentication/services/user.service';
import { errorCodes } from '@shared/constants/error-codes';
import { errorStatuses } from '@shared/constants/error-statuses';

import { ErrorActions } from '../error/store/error.slice';
import { HttpStatusCodeConstants } from '../shared/constants/http-status-code-constants';

@Injectable()
export class ApiErrorInterceptor implements HttpInterceptor {
  constructor(
    private store: Store,
    private translateService: TranslateService,
    private router: Router,
    private userService: UserService
  ) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      map((response: HttpEvent<unknown>): HttpEvent<unknown> => {
        // Filter success responses
        if (
          (response as HttpResponse<unknown>).status >=
            HttpStatusCodeConstants.ok &&
          (response as HttpResponse<unknown>).status < 400
        ) {
          this.store.dispatch(ErrorActions.resetErrors());
        }

        return response;
      }),
      timeout(30000),
      catchError((error: HttpErrorResponse): Observable<HttpEvent<unknown>> => {
        if (error.error) {
          const newError =
            typeof error.error === 'string'
              ? JSON.parse(error.error)
              : error.error;
          if (errorCodes.includes(newError.errorCode)) {
            newError.message = this.translateService.instant(
              'ERROR_CODE.'.concat(newError.errorCode)
            );
          } else if (errorStatuses.includes(error.status)) {
            newError.message = this.translateService.instant(
              'ERROR_STATUS.'.concat(error.status.toString())
            );
          }
          this.store.dispatch(ErrorActions.handleError(newError));
          if (error.status === 401) {
            this.userService.logout();
            this.router.navigate(['auth/login'], {
              queryParams: { redirect: this.router.routerState.snapshot.url },
            });
          }
        }
        return throwError(() => error);
      })
    );
  }
}
